import { FaqDto } from '.';
import { RootState } from '../../../../store/reducers';

export const selectFaq = (state: RootState): FaqDto[] => {
  return state.rankings.faq;
};
